import _ from "lodash";

export const DESC = "desc";
export const ASC = "asc";

/**
 * Funktion, welche alle Elemente von Liste a zurückgibt, welche nicht in Liste b enthalten sind
 * @param a
 * @param b
 * @returns {*}
 */
function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}

/**
 * Funktion, welche alle Elemente von Liste a zurückgibt, welche auch in Liste b enthalten sind
 * @param a
 * @param b
 * @returns {*}
 */
function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
}

/**
 * Findet das erste Element, welches dem Prädikat entspricht. Gibt ansonsten null zurück.
 *
 * @param array
 * @param predicate
 * @returns {*}
 */
function findOrNull(array, predicate) {
    return findOrElse(array, predicate, null);
}

/**
 * Findet das erste Element, welches dem Prädikat entspricht. Gibt ansonsten elseObj zurück.
 *
 * @param array Das zu durchsuchende array
 * @param predicate das prüfende Prädikat
 * @param elseObj der Rückgabewert, falls kein Element dem Prädikat entspricht
 * @returns {*}
 */
function findOrElse(array, predicate, elseObj) {
    if (!array) {
        return elseObj;
    }
    const obj = array.find(predicate);
    return obj ? obj : elseObj;
}

/**
 * Funktion, welche ein Array anhand des übergebenen Wertes sortiert. Handelt es sich bei dem zu sortierenden Objekt nicht um ein Array, wird ein leeres Array zurückgegeben.
 * @param array
 * @param orderBy
 * @param order ASC oder DESC (Konstanten der ArrayUtils)
 * @param compareValueExtractor
 * @returns {*[]}
 */
function sortBy(array, orderBy, order = DESC, compareValueExtractor = (b) => _.get(b, orderBy, undefined)) {
    if (!Array.isArray(array)) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    const comparator =
        order === DESC
            ? (a, b) => descendingComparator(a, b, orderBy, compareValueExtractor)
            : (a, b) => -descendingComparator(a, b, orderBy, compareValueExtractor);
    stabilizedThis.sort((a, b) => {
        const innerOrder = comparator(a[0], b[0]);
        if (innerOrder !== 0) return innerOrder;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy, compareValueExtractor) {
    const bItem = compareValueExtractor(b);
    const aItem = compareValueExtractor(a);
    if (!aItem) {
        return 1;
    }
    if (!bItem) {
        return -1;
    }
    if (bItem < aItem) {
        return -1;
    }
    if (bItem > aItem) {
        return 1;
    }
    return 0;
}

export {not, intersection, findOrNull, findOrElse, sortBy};
